<template>
  <v-app>
    <vue-topprogress ref="progress" color="#009688"/>
    <v-toolbar v-if="$store.getters.loggedIn" app>
      <v-icon @click="$store.state.drawer = !$store.state.drawer">menu</v-icon>
      <v-spacer></v-spacer>
      <v-menu>
        <v-avatar
          color="primary"
          slot="activator"
        >
        <v-icon>person</v-icon>
        </v-avatar>
        <v-list>
          <v-dialog
            v-model="dialog"
            :overlay="true"
            max-width="500px"
            transition="dialog-transition"
          >

          <v-list-tile slot="activator">
            <v-list-tile-avatar>
              <v-icon>edit</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>Edit Profile</v-list-tile-content>
          </v-list-tile>

          <v-card>

            <v-card-title primary-title color="primary">
              Edit Profile
            </v-card-title>

            <v-card-text>

            <v-text-field
              prepend-icon="person"
              label="name"
              v-model="$store.state.user.user.name"
              disabled
            />

            <v-text-field
              prepend-icon="email"
              label="email"
              v-model="$store.state.user.user.email"
              disabled
            />

            <hr/>

            <v-text-field
              @input="error = null"
              v-model="passwordForm.oldPassword"
              prepend-icon="lock"
              label="Old Password"
              type="password"
              required
            />

            <v-text-field
              @input="error = null"
              v-model="passwordForm.newPassword"
              prepend-icon="lock"
              label="New Password"
              type="password"
              required
            />

            <v-btn block @click.native="changePassword" color="primary">change password</v-btn>

            </v-card-text>
            
          </v-card>

          </v-dialog>
          <v-list-tile @click.native="logout">
            <v-list-tile-avatar>
              <v-icon>logout</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>Logout</v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>

    <v-content>
      <router-view></router-view>
    </v-content>

    <v-footer v-if="$store.getters.loggedIn" color="#424242" :app="true">
      <h4 style="width: 100%; text-align: center; color: #009688">Nigeria ICT Innovation and Entrepreneurship Vision</h4>
    </v-footer>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  data () {
    return {
      passwordForm: {
        oldPassword: null,
        newPassword: null
      }
    }
  },
  methods: {
    logout() {

      this.$store.commit("logout");
      this.$router.replace("/");

    },

    async changePassword() {

      this.$refs.progress.start();

      try {

        await this.$store.dispatch("changePassword", this.passwordForm);

        this.$refs.progress.done();

      } catch(error) {

        console.error(error);

        this.$refs.progress.fail();

      }

    }
  }
}
</script>
